export const OPERATOR_PIN_REGEX = /^[0-9]{4,8}$/;

export function normalizeOperatorPin(value: string): string {
  return value.replace(/[^0-9]/g, '');
}

export function isValidOperatorPin(pin: string): boolean {
  return OPERATOR_PIN_REGEX.test(pin);
}

export function formatRemainingSeconds(totalSeconds: number): string {
  const safeSeconds = Math.max(0, totalSeconds);
  const minutes = Math.floor(safeSeconds / 60);
  const seconds = safeSeconds % 60;
  return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
}
